import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { SubmitMidtermDocuments } from 'features/Project/pages';
import { Mode } from 'constant';

function MidtermDocumentEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <SubmitMidtermDocuments mode={Mode.EDIT} />
      </Layout>
    </LayoutProvider>
  );
}

export default MidtermDocumentEditPage;
